const FORM_SECTIONS = {
  PERSONAL_INFORMATION: 'personalInformation',
  PERSONAL_INFORMATION_WATCHLIST_AML: 'personalInformationWatchlistAML',
  TERMS_AND_CONDITIONS: 'termsAndConditions',
  CURRENT_RESIDENTIAL_ADDRESS: 'currentResidentialAddress',
  CURRENT_RESIDENTIAL_ADDRESS_AUTO_COMPLETE: 'currentResidentialAddressAutoComplete',
  CLIENT_REFERENCE: 'clientReference'
}

export default FORM_SECTIONS;